export const type = 'alert.totalRecipients';
